<template>
  <div class="PreMedicalRecord">
    <a-spin :spinning="loading">
      <div class="search-container" ref="searchContainerRef">
        <div class="search-item">
          <a-select
            v-model:value="search.ucDoctorAssistantIdList"
            :options="OptionsDoctorAssistant"
            mode="multiple"
            size="large"
            allowClear
            placeholder="全部健管"
            class="component"
            @change="
              () => {
                updateSearchHeight()
              }
            "
          ></a-select>
        </div>
        <div class="search-item">
          <a-select
            size="large"
            allowClear
            v-model:value="search.recordStateList"
            placeholder="预病历状态"
            mode="multiple"
            :options="[
              { label: '待医生确认', value: 0 },
              { label: '医生已确认', value: 1 },
              { label: '医生已驳回', value: 2 },
              { label: '已失效', value: 3 }
            ]"
            class="component"
            @change="
              () => {
                updateSearchHeight()
              }
            "
          />
        </div>
        <div class="search-item">
          <a-select
            size="large"
            allowClear
            v-model:value="search.buyState"
            placeholder="处方购买状态"
            :options="[
              { label: '待购买', value: 0 },
              { label: '已购买', value: 2 }
              // { label: '部分购买', value: 1 },
              // { label: '已下单未支付', value: 3 }
            ]"
            class="component"
          />
        </div>
        <div class="search-item">
          <a-range-picker
            size="large"
            class="component"
            :disabledDate="disabledDate"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
            v-model:value="rangeDate"
            :placeholder="['开始创建预病历时间', '结束创建预病历时间']"
            @change="
              (_, dateStr) => {
                search.startTime = dateStr[0] ? `${dateStr[0]} 00:00:00` : null
                search.endTime = dateStr[1] ? `${dateStr[1]} 23:59:59` : null
              }
            "
          />
        </div>
        <div class="search-item">
          <a-input
            size="large"
            allowClear
            v-model:value="search.doctorKeyword"
            placeholder="医生姓名/拼音首字母/ID/手机号搜索"
            class="component"
          />
        </div>
        <div class="search-item">
          <a-input
            size="large"
            allowClear
            v-model:value="search.patientKeyword"
            placeholder="患者姓名/拼音首字母/ID/手机号搜索"
            class="component"
          />
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" type="primary" @click="change">
            搜索
          </a-button>
          <a-button
            class="search-button"
            size="large"
            style="margin-left: 8px"
            @click="handleReset"
          >
            重置
          </a-button>
        </div>
      </div>
      <div class="data_wrap">
        <a-table
          :dataSource="dataSource"
          :columns="columns"
          :pagination="pagination"
          rowKey="advanceMedicalRecordId"
          @change="change"
          :scroll="{ x: '1600px', y: tableScrollY }"
        >
          <template #operatorName="{ text }">
            <roles :solerType="4" />
            <span>{{ text }}</span>
          </template>
          <template #patientName="{ text, record }">
            <span class="table-link" @click="handlePatientFile(record)">
              {{ text }}
            </span>
          </template>
          <template #action="{ record }">
            <span>
              <a-button @click="openPreview(record)" size="small" type="link">查看预病历</a-button>
              <a-button
                v-if="record.recordState === 1 && !isEmpty(record.parentInstanceSn)"
                @click="handleAction(record.parentInstanceSn)"
                size="small"
                type="link"
              >
                治疗方案
              </a-button>
              <!-- <a-button @click="privateChatDoctor(record)" size="small" type="link">
                联系医生
              </a-button> -->
              <a-button @click="privateChatPatient(record)" size="small" type="link">
                发起私聊
              </a-button>
            </span>
          </template>
        </a-table>
      </div>
    </a-spin>
    <PrescriptionDetails ref="prescriptionDetails" />
    <the-detail
      v-model:visible="detail.detailVisible"
      :serialNumber="detail.serialNumber"
      :recordType="detail.recordType"
      mode="read"
    />
  </div>
</template>
<script setup>
import { reactive, ref, onMounted, createVNode, computed, nextTick, onUnmounted } from 'vue'
import { columns } from './config'
import {
  doctorChatForArchives,
  listAdvanceMedicalRecord,
  listAdvanceMedicalRecordOperator
} from '@/api/HealthRecord/index.js'
import TheDetail from '@/components/TheDetail/index.vue'
import PrescriptionDetails from '@/components/PreMedicalRecordModal/PrescriptionDetails.vue'
import { isEmpty, subStringToType } from '@/utils/index'
import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import useOrder from '@/views/WorkPlace/components/WorkOrder/hooks/useOrder.js'
import { useRouter } from 'vue-router'
import { medicalGuide, patientChatForArchives } from '@/api/patientFile'
import moment from 'moment'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { cloneDeep } from 'lodash-es'

const prescriptionDetails = ref(null)
const store = useStore()
const router = useRouter()
const disabledDate = current => {
  return current && current > moment().endOf('day')
}
const loading = ref(false)
const OptionsDoctorAssistant = ref([])
const rangeDate = ref()
const defaultSearch = {
  patientKeyword: null,
  doctorKeyword: null,
  recordStateList: [],
  advanceMedicalRecordType: 6,
  startTime: null,
  endTime: null,
  buyState: null,
  ucDoctorAssistantIdList: []
}
const search = reactive({ ...defaultSearch })
const detail = reactive({
  detailVisible: false,
  serialNumber: '',
  recordType: ''
})
const pagination = ref({
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
})
const defaultCacheQuery = {
  ...defaultSearch,
  rangeDate: [],
  current: 1,
  pageSize: 10
}
const { initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.PRE_MEDICAL_RECORD_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultCacheQuery,
  normalize: params => ({
    ...cloneDeep(defaultCacheQuery),
    ...cloneDeep(params),
    recordStateList: Array.isArray(params?.recordStateList) ? params.recordStateList : [],
    ucDoctorAssistantIdList: Array.isArray(params?.ucDoctorAssistantIdList)
      ? params.ucDoctorAssistantIdList
      : [],
    rangeDate: Array.isArray(params?.rangeDate) ? params.rangeDate : []
  })
})
const dataSource = ref([])
const applyCacheQuery = cacheQuery => {
  Object.assign(search, defaultSearch, cacheQuery)
  rangeDate.value = cacheQuery.rangeDate || []
  pagination.value.current = cacheQuery.current || 1
  pagination.value.pageSize = cacheQuery.pageSize || 10
}

const persistCache = () => {
  updateCache({
    ...search,
    rangeDate: rangeDate.value || [],
    current: pagination.value.current,
    pageSize: pagination.value.pageSize
  })
}

const handleSearch = async () => {
  loading.value = true
  const params = {
    ...search,
    pageSize: pagination.value.pageSize,
    pageNo: pagination.value.current
  }
  try {
    const result = await listAdvanceMedicalRecord(params)
    const { list, totalCount } = result
    dataSource.value = list
    pagination.value.total = totalCount
    pagination.value.showTotal = () => `共${totalCount}条`
  } catch (error) {
    dataSource.value = []
  } finally {
    loading.value = false
  }
}
const handleAction = serialNumber => {
  detail.serialNumber = serialNumber
  detail.recordType = subStringToType(serialNumber)
  detail.detailVisible = true
}
const { changeToProcess } = useOrder()
// 私聊医生
const privateChatDoctor = async record => {
  console.log(`output->`, record)
  const handlePrivateChat = async createFlag => {
    try {
      const params = {
        patientId: record.patientId,
        ucPatientId: record.ucPatientId,
        ucDoctorId: record.ucDoctorId,
        createFlag
      }
      const res = (await doctorChatForArchives(params)) || {}
      const { titleType } = res
      switch (titleType) {
        case 0:
          Modal.confirm({
            title: () => '提示',
            icon: () => createVNode(ExclamationCircleOutlined),
            content: () => res.title,
            onOk() {
              handlePrivateChat(1)
            },
            onCancel() {}
          })
          break
        // 只是提示
        case 2:
        case 7:
          Modal.warn({
            title: () => '提示',
            content: res.title,
            onOk() {
              console.log('ok')
            }
          })
          break
        case 5:
          Modal.confirm({
            title: () => '提示',
            icon: () => createVNode(ExclamationCircleOutlined),
            content: () => res.title,
            okText: '继续沟通',
            onOk() {
              // 切换至坐班接收状态
              store.dispatch('user/handleChangeWorkStatus', { status: 0 }).then(async () => {
                // 0 - 坐班中(接收) 1 - 休息中 2 - 坐班中(拒收)
                await store.dispatch('user/queryShiftStaus')
                handlePrivateChat(0)
              })
            }
          })
          break
        case 6:
          Modal.confirm({
            title: () => '提示',
            content: res.title,
            onOk() {
              const params = {
                patientId: record.patientId,
                ifSendHelloMsg: 0
              }
              medicalGuide(params).then(_ => {
                handlePrivateChat(1)
              })
            }
          })
          break
        default:
          toPrivateGroup(res.groupId)
          break
      }
    } catch (error) {
      console.log(error)
    }
  }
  handlePrivateChat(0)
}
// 私聊患者
const privateChatPatient = record => {
  // 发起私聊  createFlag先传0，如果有弹窗：是否继续创建，点击确认再传1
  const handlePrivateChat = async createFlag => {
    try {
      const params = {
        patientId: record.patientId,
        ucPatientId: record.ucPatientId,
        ucDoctorId: record.ucDoctorId,
        createFlag
      }
      const res = (await patientChatForArchives(params)) || {}
      const { titleType } = res
      /**
      title 类型
      HAVE_UN_PRIVATE(0, "已有非私聊"),
      HAVE_DONE_PRIVATE(2, "已有进行中私聊-非当前健管"),
      HAVE_DONE_PRIVATE_ON_DA(1, "已有进行中私聊-当前健管"),
      HAVE_PENDING_PRIVATE(3, "有待分配、待处理私聊"),
      HAVE_NO_WORK_ORDER(4, "不存在任何工单"),
      DA_ASSISTANT_NOT_ONLINE(5, "健管不在坐班中"),
      NO_GUIDE_CONSULT_GROUP(6,"没有导诊群"),
      CAN_NOT_CREATE_GUIDE(7,"不能创建导诊群")
     */
      switch (titleType) {
        case 0:
          Modal.confirm({
            title: () => '提示',
            icon: () => createVNode(ExclamationCircleOutlined),
            content: () => res.title,
            onOk() {
              handlePrivateChat(1)
            },
            onCancel() {}
          })
          break
        // 只是提示
        case 2:
        case 7:
          Modal.warn({
            title: () => '提示',
            content: res.title,
            onOk() {
              console.log('ok')
            }
          })
          break
        case 5:
          Modal.confirm({
            title: () => '提示',
            icon: () => createVNode(ExclamationCircleOutlined),
            content: () => res.title,
            okText: '继续沟通',
            onOk() {
              // 切换至坐班接收状态
              store.dispatch('user/handleChangeWorkStatus', { status: 0 }).then(async () => {
                // 0 - 坐班中(接收) 1 - 休息中 2 - 坐班中(拒收)
                await store.dispatch('user/queryShiftStaus')
                handlePrivateChat(0)
              })
            }
          })
          break
        case 6:
          Modal.confirm({
            title: () => '提示',
            content: res.title,
            onOk() {
              const params = {
                patientId: record.patientId,
                ifSendHelloMsg: 0
              }
              medicalGuide(params).then(_ => {
                handlePrivateChat(1)
              })
            }
          })
          break
        default:
          toPrivateGroup(res.groupId)
          break
      }
    } catch (error) {
      console.log(error)
    }
  }
  // console.log(`output->`, record)
  handlePrivateChat(0)
}
// 跳转到患者私聊群
const toPrivateGroup = groupId => {
  router.push({
    path: '/workplace'
  })
  // store.commit('patientFile/SET_STATE', 2)
  store.commit('workOrder/SET_CHART_ID', String(groupId))
  changeToProcess()
}

// 打开预览
const openPreview = record => {
  const { advanceMedicalRecordId } = record
  if (!advanceMedicalRecordId) return
  prescriptionDetails.value?.initModal(advanceMedicalRecordId)
}
const handleReset = () => {
  Object.assign(search, defaultSearch)

  pagination.value.current = 1
  pagination.value.pageSize = 10

  rangeDate.value = []
  persistCache()
  change()
}
const change = page => {
  pagination.value.current = page?.current || 1
  pagination.value.pageSize = page?.pageSize || 10
  persistCache()
  handleSearch()
}
const getOptionsDoctorAssistant = async () => {
  OptionsDoctorAssistant.value = []
  const params = {
    advanceMedicalRecordType: 6
  }
  const res = await listAdvanceMedicalRecordOperator(params)
  OptionsDoctorAssistant.value = res.map(one => {
    return {
      ...one,
      value: one.ucOperatorId,
      label: one.operatorRecordCount
        ? `${one.operatorName}，提交数:${one.operatorRecordCount}`
        : one.operatorName
    }
  })
}
const searchContainerRef = ref(null)
const searchContainerHeight = ref(0)
const tableScrollY = computed(() => {
  const fixedHeight = 240
  return `calc(100vh - ${fixedHeight + searchContainerHeight.value}px)`
})
// 查看患者信息
const handlePatientFile = record => {
  const { patientId, doctorId } = record
  const param = {
    patientId: patientId,
    patientType: 1,
    doctorId: doctorId
  }
  store.dispatch('patientFile/openModal', param)
}

const updateSearchHeight = () => {
  nextTick(() => {
    searchContainerHeight.value = searchContainerRef.value?.offsetHeight || 0
  })
}
onMounted(() => {
  updateSearchHeight()
  window.addEventListener('resize', updateSearchHeight)
  applyCacheQuery(initFromCache())
  change()
  getOptionsDoctorAssistant()
})
onUnmounted(() => {
  window.removeEventListener('resize', updateSearchHeight)
})
</script>
<style scoped lang="scss">
.PreMedicalRecord {
  height: 100%;
  .search-container {
    padding: 10px 20px 0;
    background-color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    .search-item {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 12px;
      width: 310px;

      .component {
        width: 100%;
      }
    }
  }
  .data_wrap {
    height: 100%;
    margin: 20px;
    padding: 20px;
    background-color: #ffffff;
    .table-link {
      color: #1890ff;
      cursor: pointer;
    }
  }
}
</style>
